import { render, staticRenderFns } from "./enforceability.vue?vue&type=template&id=630653b6"
import script from "./enforceability.vue?vue&type=script&lang=js"
export * from "./enforceability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports